export default "__VITE_ASSET__DcDUB0TR__"